import { USER_ROLES } from "@/constants/auth";
import useAuthStore from "@/context/auth/useAuthStore";
import { canAccessContracts } from "@/router/routeAccess";
export function usePermissions() {
    const { userRole } = useAuthStore();
    const isSuperAdmin = userRole === USER_ROLES.SUPERADMIN;
    const isAdmin = userRole === USER_ROLES.ADMIN;
    const isViewer = userRole === USER_ROLES.VIEWER;
    const isUser = userRole === USER_ROLES.USER;
    const canViewBillingData = isSuperAdmin || isAdmin || isViewer;
    return {
        userRole,
        isSuperAdmin,
        isAdmin,
        isViewer,
        isUser,
        canViewContracts: canAccessContracts(userRole),
        canViewInvoices: canViewBillingData,
        canViewAuditLogs: canViewBillingData,
        canGenerateLicense: isSuperAdmin || isAdmin,
        canRegenerateLicense: isSuperAdmin,
        canReissueResolveToken: isSuperAdmin,
        canDownloadLicense: isSuperAdmin || isAdmin,
        canViewLicenses: isSuperAdmin || isAdmin
    };
}
export default usePermissions;
